
module.exports = { 
      attributes: {},
    
      body: "Sexual and reproductive health provides education and support to individuals. Services may include:\n\n- sexually transmitted services\n- contraception\n- health promotion and education like safe sex\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/sexual-and-reproductive-health.md"},
     }